/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_SuffixInputs */

const en_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/month`)
};

const id_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/bulan`)
};

const ms_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/bulan`)
};

const ca_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

const cs_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/měsíc`)
};

const da_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/måned`)
};

const de_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/monat`)
};

const et_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/kuu`)
};

const es_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

const fr_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mois`)
};

const hr_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mjesec`)
};

const it_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mese`)
};

const lv_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ mēnesī`)
};

const lt_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ per mėnesį`)
};

const hu_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/hónap`)
};

const nl_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/maand`)
};

const nb_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/måned`)
};

const pl_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/miesiąc`)
};

const pt_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mês`)
};

const ro_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/lună`)
};

const sk_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mesiac`)
};

const sl_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mesec`)
};

const fi_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/kuukausi`)
};

const sv_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/månad`)
};

const vi_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/tháng`)
};

const tr_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ay`)
};

const el_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/μήνα`)
};

const bg_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/месец`)
};

const ru_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/месяц`)
};

const sr_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`месечно`)
};

const uk_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/місяць`)
};

const ka_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/თვე`)
};

const hi_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/महीना`)
};

const th_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/เดือน`)
};

const ko_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/월`)
};

const zh_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

const zh_tw_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

const ja_monthly_suffix = /** @type {(inputs: Monthly_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

/**
* | output |
* | --- |
* | "/month" |
*
* @param {Monthly_SuffixInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const monthly_suffix = /** @type {((inputs?: Monthly_SuffixInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_SuffixInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_monthly_suffix(inputs)
	if (locale === "ms") return ms_monthly_suffix(inputs)
	if (locale === "ca") return ca_monthly_suffix(inputs)
	if (locale === "cs") return cs_monthly_suffix(inputs)
	if (locale === "da") return da_monthly_suffix(inputs)
	if (locale === "de") return de_monthly_suffix(inputs)
	if (locale === "et") return et_monthly_suffix(inputs)
	if (locale === "es") return es_monthly_suffix(inputs)
	if (locale === "fr") return fr_monthly_suffix(inputs)
	if (locale === "hr") return hr_monthly_suffix(inputs)
	if (locale === "it") return it_monthly_suffix(inputs)
	if (locale === "lv") return lv_monthly_suffix(inputs)
	if (locale === "lt") return lt_monthly_suffix(inputs)
	if (locale === "hu") return hu_monthly_suffix(inputs)
	if (locale === "nl") return nl_monthly_suffix(inputs)
	if (locale === "nb") return nb_monthly_suffix(inputs)
	if (locale === "pl") return pl_monthly_suffix(inputs)
	if (locale === "pt") return pt_monthly_suffix(inputs)
	if (locale === "ro") return ro_monthly_suffix(inputs)
	if (locale === "sk") return sk_monthly_suffix(inputs)
	if (locale === "sl") return sl_monthly_suffix(inputs)
	if (locale === "fi") return fi_monthly_suffix(inputs)
	if (locale === "sv") return sv_monthly_suffix(inputs)
	if (locale === "vi") return vi_monthly_suffix(inputs)
	if (locale === "tr") return tr_monthly_suffix(inputs)
	if (locale === "el") return el_monthly_suffix(inputs)
	if (locale === "bg") return bg_monthly_suffix(inputs)
	if (locale === "ru") return ru_monthly_suffix(inputs)
	if (locale === "sr") return sr_monthly_suffix(inputs)
	if (locale === "uk") return uk_monthly_suffix(inputs)
	if (locale === "ka") return ka_monthly_suffix(inputs)
	if (locale === "hi") return hi_monthly_suffix(inputs)
	if (locale === "th") return th_monthly_suffix(inputs)
	if (locale === "ko") return ko_monthly_suffix(inputs)
	if (locale === "zh") return zh_monthly_suffix(inputs)
	if (locale === "zh-tw") return zh_tw_monthly_suffix(inputs)
	if (locale === "ja") return ja_monthly_suffix(inputs)
	return en_monthly_suffix(inputs)
});